import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVisa = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 48,
	height: 24,
	viewBox: "0 0 48 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("g", { children: /* @__PURE__ */ _jsx("g", {
		id: "Type=Visa",
		children: /* @__PURE__ */ _jsxs("g", {
			id: "Vector",
			children: [
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_2",
					d: "M19.9805 15.9074L21.3209 8.13525H23.4154L22.1168 15.9074H19.9805Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_3",
					d: "M29.6996 8.22189C29.2807 8.04918 28.6105 7.87646 27.7727 7.87646C25.6782 7.87646 24.1702 8.95592 24.1702 10.5103C24.1702 11.6762 25.2174 12.2807 26.0552 12.6693C26.893 13.0579 27.1444 13.3169 27.1444 13.6624C27.1444 14.1805 26.4741 14.4396 25.8877 14.4396C25.0499 14.4396 24.5891 14.3101 23.877 14.0078L23.5838 13.8783L23.2905 15.6486C23.7932 15.8645 24.7148 16.0804 25.6782 16.0804C27.8984 16.0804 29.3645 15.0009 29.3645 13.3601C29.3645 12.4534 28.8199 11.7625 27.5633 11.2012C26.8092 10.8126 26.3485 10.5967 26.3485 10.2081C26.3485 9.86267 26.7255 9.51724 27.5633 9.51724C28.2754 9.51724 28.7781 9.64678 29.1551 9.81949L29.3645 9.90585L29.6996 8.22189Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_4",
					d: "M33.3021 8.13525C32.7995 8.13525 32.4224 8.17843 32.213 8.69657L29.0713 15.9074H31.3333L31.7522 14.612H34.4331L34.6845 15.9074H36.6952L34.9358 8.13525H33.3021ZM32.3387 13.3167C32.4643 12.9281 33.1765 11.0282 33.1765 11.0282C33.1765 11.0282 33.344 10.5532 33.4697 10.251L33.5954 10.985C33.5954 10.985 34.0142 12.9281 34.098 13.3598H32.3387V13.3167Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_5",
					d: "M16.1266 13.5755L15.9171 12.4529C15.5401 11.1575 14.3253 9.73265 12.9849 9.04179L14.8699 15.9503H17.1319L20.525 8.17822H18.2629L16.1266 13.5755Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_6",
					d: "M10.3047 8.13525L10.6817 8.22161C13.3626 8.86929 15.2058 10.5101 15.9179 12.4531L15.1639 8.78293C15.0382 8.26479 14.6612 8.13525 14.2004 8.13525H10.3047Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_7",
					d: "M10.3047 8.13525C12.9856 8.78293 15.2058 10.4669 15.9179 12.4099L15.2058 9.34425C15.0801 8.82611 14.6612 8.52386 14.2004 8.52386L10.3047 8.13525Z",
					fill: "white"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Vector_8",
					d: "M10.3047 8.13525C12.9856 8.78293 15.2058 10.4669 15.9179 12.4099L15.4152 10.726C15.2895 10.2078 15.122 9.68968 14.5355 9.47379L10.3047 8.13525Z",
					fill: "white"
				})
			]
		})
	}) })
});
export default SvgVisa;
